import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';

import HitWithWishlist from './HitWithWishlist';
import Product from '../../components/result/Product';

export default function CatalogHit({ results, hit, additionalData }: componentTypes.HitProps) {
  return (
    <HitWithWishlist
      results={results}
      hit={hit}
      additionalData={additionalData}
      component={Product}
    />
  );
}
